import { render, staticRenderFns } from "./ChangeOwnerView.vue?vue&type=template&id=e43a05f6&"
import script from "./ChangeOwnerView.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43a05f6')) {
      api.createRecord('e43a05f6', component.options)
    } else {
      api.reload('e43a05f6', component.options)
    }
    module.hot.accept("./ChangeOwnerView.vue?vue&type=template&id=e43a05f6&", function () {
      api.rerender('e43a05f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/ChangeOwnerView.vue"
export default component.exports